import React from 'react';

const InputComponent = ({
    label,
    id,
    name,
    value,
    onChange,
    placeholder,
    className,
    readOnly,
    required,
    error,
    type = "text",
}) => {
    return (
        <div className={`w-full flex flex-col items-start justify-center gap-1 ${readOnly && 'opacity-50 cursor-not-allowed'}`}>
            <label htmlFor={id} className="text-sm text-gray-500">
                {label} {required && <span className="text-red-500"> *</span>}
            </label>
<input
    type={type}
    id={id}
    name={name}
    placeholder={placeholder ? placeholder : label}
    className={`w-full h-8 p-2 text-sm border rounded-md outline-none ${
        error
            ? "border-red-500 "
            : "active:border-cus-blue focus:border-cus-blue"
    } ${className} ${readOnly && 'pointer-events-none'}`}
    onChange={onChange}
    value={value}
    readOnly={readOnly}
    onWheel={(e) => {
        if (type === "number") {
            e.target.blur();
        }
    }}
/>
            {error && <p className="text-red-500 text-xs mt-1">{error}</p>}
        </div>
    );
};

export default InputComponent;
